// main.tsx — SPA entry point. badges.css (the StatusBadge contrast pairs) is
// imported before the app's own index.css so the app can override it.
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'common/badges.css';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
